import _ from "lodash";
import { useEffect } from "react";
import { Hooks, TableInstance, usePagination } from "react-table";

const useInstance = <T extends object>(instance: TableInstance<T>) => {
  const {
    state: { pageIndex, pageSize, isLoading },
    totalCount,
    gotoPage,
    previousPage,
    canPreviousPage,
    rows,
  } = instance;
  const shouldResetPageCount =
    !_.isUndefined(pageSize) && !_.isUndefined(totalCount);
  if (shouldResetPageCount) {
    // eslint-disable-next-line no-param-reassign
    instance.pageCount = Math.ceil(totalCount / pageSize);
  }
  const newPageCount = instance.pageCount;
  useEffect(() => {
    if (
      _.isFunction(gotoPage) &&
      shouldResetPageCount &&
      newPageCount < pageIndex + 1
    ) {
      gotoPage(0);
    }
  }, [newPageCount, gotoPage, pageIndex, shouldResetPageCount]);
  useEffect(() => {
    if (totalCount && !rows.length && !isLoading && canPreviousPage) {
      previousPage();
    }
  }, [totalCount, rows, canPreviousPage, previousPage, isLoading]);
};

/**
 * Patched version of usePagination which supports receiving a totalCount and
 * will use that to properly set pageCount.
 */
const usePaginationPatched = <T extends object>(hooks: Hooks<T>) => {
  hooks.useInstance.push(useInstance);
  usePagination(hooks);
};
usePaginationPatched.pluginName = "usePagination";

export default usePaginationPatched;
